module.exports = __webpack_public_path__ + "static/media/Passimian_gaussian2.387f0ff6.png";